import React from 'react'
import { Modal, Button, Group, Text, Title } from '@mantine/core'

const Alert = ({
  isOpen,
  onClose,
  title,
  message,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancel,
  confirmColor = '#97a4b4',
  cancelColor = '#6c757d',
  showCancel = true,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()
    }
    onClose()
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    }
    onClose()
  }

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={title}
      withCloseButton={false}
      centered
      size="sm"
      styles={{
        title: {
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '18px',
          width: '100%',
        },
        header: {
          justifyContent: 'center',
        },
        body: {
          textAlign: 'center',
          padding: '20px',
        },
      }}
    >
      <Text size="md" style={{ marginBottom: '20px', lineHeight: 1.5 }}>
        {message}
      </Text>

      <Group justify="center" gap="md">
        {showCancel && (
          <Button
            variant="outline"
            onClick={handleCancel}
            style={{
              borderColor: cancelColor,
              color: cancelColor,
              minWidth: '80px',
            }}
          >
            {cancelText}
          </Button>
        )}
        <Button
          onClick={handleConfirm}
          style={{
            backgroundColor: confirmColor,
            minWidth: '80px',
          }}
        >
          {confirmText}
        </Button>
      </Group>
    </Modal>
  )
}

export default Alert
